module.exports = __webpack_public_path__ + "static/img/logo_energizar_small_300x300.f55b514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_energizar_small_300x300.png
// module id = B7Nt
// module chunks = 1